import React from 'react'
import Quality from '../Images/1.png';
import Delivery from '../Images/2.png';
import FreshFarm from '../Images/3.png';
import Opendays from '../Images/4.png';
import Access from '../Images/5.png';


export const Service = () => {
  return (
    <div className='service'>
        <div className="service-container">
            <div className="service-img-box">
                <div className="img-box">
                <img src={Quality} alt='bannerpic' />
            </div><h4>High Quality</h4>
            </div>

            <div className="service-img-box">
            <div className="img-box">
            <img src={Delivery} alt='bannerpic' />
            </div><h4>Fast delivery</h4>
            </div>

            <div className="service-img-box">
            <div className="img-box">
            <img src={FreshFarm} alt='bannerpic' />
            </div><h4>Fresh from farm</h4>
            </div>

            <div className="service-img-box">
            <div className="img-box">
            <img src={Opendays} alt='bannerpic' />
            </div><h4>Open 365 days</h4>
            </div>

            <div className="service-img-box">
            <div className="img-box">
            <img src={Access} alt='bannerpic' /> 
            </div><h4>Easy to access</h4>
            </div>
        </div>
    </div>
  )
}
